import { Component, Input } from '@angular/core';

@Component({
    selector: 'admin-report-selector',
    template: require('./reports.selector.component.html')
})
export class SiteAdminReportSelectorComponent {

    @Input() reportName: string = '';

}